<template>
    <div style="background-color: white">
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="getUpdateLogData(1)"
                      class="form-inline my-2 my-lg-0">
                    <date-picker v-model="search.date"
                                 range
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                 :format="changeFormat"
                                 :lang="lang" confirm>
                    </date-picker>
                    &nbsp;
                    <b-form-select
                        v-model="search.type"
                        :options="optionTopic"></b-form-select>&nbsp;
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="getUpdateLogData(1)">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp;
                    <button
                        @click="printUpdateLogData"
                        class="btn btn-primary my-2 my-sm-0"
                        type="button">
                        <icon name="print"></icon>
                        พิมพ์รายงานอัพเดต
                    </button>&nbsp;
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th>วันที่</th>
                    <th>เมนูอัพเดต</th>
                    <th>รายการอัพเดต</th>
                    <th>รายละเอียดการอัพเดต</th>
                    <th>ประเภทการอัพเดต</th>
                    <th>ผู้อัพเดต</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in table_data">
                    <td>{{ data.updated_at | moment("DD/MM/YYYY") }}</td>
                    <td>{{ data.topic_name }}</td>
                    <td style="text-align: left">
                        <template v-if="data.customer">
                            {{ data.customer.customer_id }}&nbsp;
                            {{ data.customer.store_name }}
                        </template>
                        <template v-if="data.product">
                            {{ data.product.sku }}&nbsp;
                        </template>
                        <template v-if="data.promotion">
                            {{ data.promotion.name }}&nbsp;
                        </template>
                    </td>
                    <td style="text-align: left">
                        <template v-if="data.description">
                            <template v-if="data.customer">
                                <div v-for="description in data.description">
                                    {{ description }}
                                </div>
                            </template>
                            <template v-else-if="data.promotion">
                                <div v-html="data.description">
                                </div>
                            </template>
                            <template v-else>
                                <div v-html="data.description">
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        {{ data.type }}
                    </td>
                    <td>
                        {{ data.user ? data.user.name : '-' }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getUpdateLogData(dataPaginate.current_page)">
        </vue-pagination>
        <!--        <pre>{{table_data}}</pre>-->
    </div>
</template>

<script>
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import VuePagination from "../Pagination";
import Loading from "../Utility/Loading";

export default {
    name: "ReportUpdateData",
    components: {
        Loading,
        VuePagination,
        DatePicker,
    },
    data() {
        return {
            status_loading: 1,
            msg: '',
            search: {
                date: [],
                type: '',
            },
            table_data: [],
            optionTopic: [
                {
                    value: "",
                    text: "ค้นหารายการอัพเดต"
                },
                {
                    value: 'customer',
                    text: "อัพเดตลูกค้า"
                },
                {
                    value: "product",
                    text: "อัพเดตสินค้า"
                },
                {
                    value: "transport_fee",
                    text: "อัพเดตค่าเที่ยว"
                },
                {
                    value: "transport_foam",
                    text: "อัพเดตค่าขนส่ง"
                },
                {
                    value: "promotion",
                    text: "รายการโปรโมชั่น"
                },
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
        }
    },
    created() {
        this.getUpdateLogData(1);
    },
    methods: {
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getUpdateLogData(page) {
            let data = {
                start_date: this.search.date.length > 0 && this.search.date[0] ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                end_date: this.search.date.length > 0 && this.search.date[1] ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                type: this.search.type,
            }
            this.$store.dispatch("Dashboard/getUpdateLogData", {page, data}).then(res => {
                this.table_data = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to,
                }
            })
        },
        printUpdateLogData() {
            let data = {
                start_date: this.search.date.length > 0 && this.search.date[0] ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                end_date: this.search.date.length > 0 && this.search.date[1] ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                type: this.search.type,
            };
            this.status_loading = 1;
            this.msg = "กำลังกาวโหลดข้อมูลกรุณารอสักครู่";
            this.showLoadingModal();
            this.$store.dispatch("Dashboard/printUpdateLogData", data).then(url => {
                if (url) {
                    window.open(url, '_blank');
                    this.hideLoadingModal();
                } else {
                    this.status_loading = 3;
                    this.msg = "ไม่มีข้อมูลให้ดาวโหลด";
                    this.showLoadingModal();
                }
            }).catch(() => {
                this.status_loading = 3;
                this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                this.showLoadingModal();
            })
        }
    }
}
</script>

<style scoped>

</style>
